module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"UploadImageSizeStr":"Uploaded file size cannot exceed","ImageSizeLimit":"Image dimensions must be {width}×{height} pixels"},"zh":{"UploadImageSizeStr":"上传文件大小不能超过","ImageSizeLimit":"图片的尺寸必须是  {width}*{height} (宽*高)"},"mm":{"UploadImageSizeStr":"တင်မည့်ပုံသည် ဆိုဒ် ထက်မပိုရ","ImageSizeLimit":"ပုံ၏အရွယ်အစားသည် {width} * {height} (အကျယ်*အမြင့်) ဖြစ်ရမည်"}}')
  delete Component.options._Ctor
}
